import { SectionHeader } from "./SectionHeader";

const Section = ({
  id = '',
  title = 'Title',
  subline = 'Subline',
  image = null,
  isDarkBg = false,
  dataAos = 'fade',
  children = null,
  dataAosDelay,
  dataAosDuration,
  hasDashline = true,
  invertedHeaderColors = false,
  hideHeader = false,
  invertedTextColor = false,
  lang = 'de'
}) => {
  
  const bgColorClass = isDarkBg ? 'bg-[#F5F5F5]' : 'bg-transparent';
  
  // Set the content and image width classes based on image presence
  // Text/Children gets 2/3 width, Image gets 1/3 width
  const contentWidthClass = image ? 'md:w-2/3' : 'w-full';
  const imageWidthClass = 'md:w-1/3 flex-shrink-0';
  
  // Container for the content and image (below the header)
  const contentWrapperClasses = image ? "md:flex md:gap-16" : "";
  
  // Adding dashline class
  const dashlineClass = hasDashline ? "dashline" : "";
  
  return (
    // Apply the background class to the <section> element
    <section id={id} lang={lang} className={`py-16 px-6 ${bgColorClass} ${dashlineClass}`}> 
      <div
          className="container mx-auto dpr-max-w-container font-light text-xl leading-snug"
          data-aos={dataAos}
          data-aos-delay={dataAosDelay}
          data-aos-duration={dataAosDuration ? dataAosDuration : undefined}
        >

        {/* 1. SECTION HEADER (Always full width) */}
        {!hideHeader && (
          <SectionHeader
              subline={subline}
              headline={title}
              invertedColors={invertedHeaderColors}
            />
        )}
        
        {/* 2. CONTENT AREA (Conditional Flex Layout below header) */}
        <div className={contentWrapperClasses}> 
            
            {/* A. TEXT/CHILDREN (Left Column) */}
            <div className={`content-text ${contentWidthClass} ${invertedTextColor ? 'inverted' : ''}`}>
                {children}
            </div>
            
            {/* B. IMAGE (Right Column - only rendered if 'image' prop is passed) */}
            {image && (
                // Use mt-8/mb-4 on mobile and mt-0 on desktop to align the image properly 
                // and give it space from the header.
                <div className={`${imageWidthClass} mt-8 mb-4 md:mt-0`}> 
                    {image}
                </div>
            )}

        </div>
      </div>
    </section>
  );
};

export { Section };